import React, { Component } from 'react'
import { Link } from 'react-router-dom'
export default class Header extends Component {
  render() {
    return (
      <React.Fragment>
        <nav class="navbar navbar-expand-lg bg-bgary">
          <div class="container">
            <div className='logo-area'>
              <a class="navbar-brand" href="/"><img src="/assets/home/rozgar.png" alt="" className="logo" /></a>
              <span className='pla-del'>Placements. <span>Delivered.</span></span>
            </div>
            <div>
              <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                  <Link to="/AboutUs" class="nav-link">About Us</Link>
                </li>
                <li class="nav-item">
                  <a href="/ContactUs" class="nav-link">Contact Us</a>
                </li>
                <li class="nav-item">
                  <Link to="/login" className="register-btn">
                    <i class="bi bi-box-arrow-in-right"></i> Login
                  </Link>
                </li>
                {/* <li class="nav-item">
                  <Link to="/login" className="register-btn">
                    <i class="bi bi-person-plus"></i> Register
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        </nav>
      </React.Fragment>
    )
  }
}
